import PortableText from '@/components/portableText';
import FollowOnSocialMedia from '@/components/profile/FollowOnSocialMedia';
import { ArbitraryTypedObject } from '@portabletext/types';

type BiographyProps = {
  biography: ArbitraryTypedObject;
  firstName?: string;
  socialMediaLinks?: (string | null | undefined)[];
};

const Biography = ({
  biography,
  firstName,
  socialMediaLinks,
}: BiographyProps) => (
  <div data-testid='biography'>
    <PortableText value={biography} />
    {firstName && socialMediaLinks && socialMediaLinks.length > 0 && (
      <FollowOnSocialMedia firstName={firstName} links={socialMediaLinks} />
    )}
  </div>
);

export default Biography;
